import React from 'react'
import YouTube from 'react-youtube'

import './style.css'

const YOUTUBE_VIDEO_ID_REGEX = /^[A-Za-z0-9_-]{11}$/

export const normalizeYouTubeVideoId = (videoId) => {
  if (!videoId || typeof videoId !== 'string') {
    return ''
  }

  const trimmedVideoId = videoId.trim()

  if (YOUTUBE_VIDEO_ID_REGEX.test(trimmedVideoId)) {
    return trimmedVideoId
  }

  try {
    const parsedUrl = new URL(trimmedVideoId)
    const hostname = parsedUrl.hostname.replace(/^www\./, '')

    if (hostname === 'youtu.be') {
      const shortId = parsedUrl.pathname.split('/').filter(Boolean)[0]
      return YOUTUBE_VIDEO_ID_REGEX.test(shortId) ? shortId : ''
    }

    if (hostname === 'youtube.com' || hostname === 'm.youtube.com') {
      const watchId = parsedUrl.searchParams.get('v')
      if (YOUTUBE_VIDEO_ID_REGEX.test(watchId)) {
        return watchId
      }

      const pathParts = parsedUrl.pathname.split('/').filter(Boolean)
      const embedId = pathParts[pathParts.length - 1]
      return YOUTUBE_VIDEO_ID_REGEX.test(embedId) ? embedId : ''
    }
  } catch (error) {
    return ''
  }

  return ''
}

const Player = ({ videoId, options, autoplay = 1, ...props }) => {
  const normalizedVideoId = normalizeYouTubeVideoId(videoId)

  if (!normalizedVideoId) {
    return null
  }

  const opts = {
    height: '100%',
    width: '100%',
    playerVars: {
      // https://developers.google.com/youtube/player_parameters
      autoplay,
      mute: 0,
    },
    ...options,
  }

  return (
    <YouTube
      containerClassName="video-responsive"
      className="youtube-player"
      videoId={normalizedVideoId}
      opts={opts}
      {...props}
    />
  )
}

export default React.memo(Player)
